


<div class="col-lg-12" style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;padding: 0px;">
    <!-- !----card strat!---! -->
    <div class="main-card mb-3 card">
      <div class="card-body">
        <!-- !---!card body start---! -->
        <div class="mains" style="align-items: center;justify-content: space-between;">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb " style="background-color: none !important;">
              <li class="breadcrumb-item"><a href="#" style="color:#0071bc;"><i class="bi bi-house-add-fill mx-1" style="color:#0071bc"></i>Home</a></li>
              <li class="breadcrumb-item active" style="color: darkgray;">Hotspot Account Status</li>
            </ol>
          </nav>
      
         <div class="sub" >
          <button class="btn  text-center text-white mx-3" (click)="openLarge(content1)" style="background-color: green;"><span class=" text-white"><i class="bi bi-plus"  id="s"></i></span>Add</button>
          <button class="btn  text-center text-white mx-3" (click)="openLarge(content1)" style="background-color: deeppink;"><span><i class="bi bi-pen-fill mx-1" id="s"></i></span>Edit</button>
          <button class="btn  text-center text-white mx-3"(click)="openSmall(content7)" style="background-color: dodgerblue;"><span><i class="bi bi-search mx-1" id="s"></i></span>Search</button>
          <button class="btn  text-center text-white mx-3" (click)="Delete()" style="background-color: red;"><span><i class="bi bi-x "  id="s"></i></span>Delete</button>
         </div>
         <button class="btn" style="border-radius:5px;display:none;background-color: orangered;" id="show" (click)="display()" > <i class="bi bi-three-dots-vertical text-white "></i></button> 
       </div> 
       <!-- !-----!----! -->
        <div class="mobile-only">
       <div class="container" style="padding:20px;background-color:azure; display:flex;justify-content: space-between;"        *ngIf="visible">
         <button class="btn  text-center text-white "  (click)="openLarge(content1)" id="c" style="background-color:darkgreen"><span class=" text-white"><i class="bi bi-plus" id="selected" ></i></span></button>
        <button class="btn  text-center text-white "  (click)="openLarge(content1)" id="c" style="background-color:deeppink"><span><i class="bi bi-pen " id="selected"></i></span></button>
         <button class="btn  text-center text-white "  (click)="openSmall(content7)" id="c" style="background-color: dodgerblue;"><span><i class="bi bi-search  "id="selected"></i></span></button>
         <button class="btn  text-center text-white "  (click)="Delete()" id="c" style="background-color: red;"><span><i class="bi bi-x"id="selected"></i></span></button>
       </div> 
       </div> 
        <!-- !-----! -->
        <div class="table-responsive">
          <!-- !----!---! -->
        <table class="mb-0 table table-striped">
          <thead style="background-color:#0071bc;">
            <tr >
              <th id="common" class="border border-white text-center">
                <div style="vertical-align: middle;">
                  <input type="checkbox"  [(ngModel)]="selectall" (change)="child()">
                </div>
              </th>
              <th scope="col" class="text-white border border-white" id="common"  >Unique ID</th>
              <th scope="col" class="text-white border border-white" id="common" >User ID</th>
              <th scope="col" class="text-white border border-white" id="common" >Account State</th>
              <th scope="col" class="text-white border border-white" id="common" >Name</th>
              <th scope="col" class="text-white border border-white" id="common">Quota</th>
              <th scope="col" class="text-white border border-white" id="common" >Today</th>
              <th scope="col" class="text-white border border-white" id="common" >This Week</th>
              <th scope="col" class="text-white border border-white" id="common" >This Month</th>
              <th scope="col" class="text-white border border-white" id="common" >Life Time Total</th>
              <th scope="col" class="text-white border border-white" id="common">Topup used</th>
              <th scope="col" class="text-white border border-white" id="common" >Month Usage Form</th>
              <th scope="col" class="text-white border border-white" id="common" >Quota(Minutes)</th>
              <th scope="col" class="text-white border border-white" id="common" >Today</th>
              <th scope="col" class="text-white border border-white" id="common" >This Week</th>
              <th scope="col" class="text-white border border-white" id="common" >This Month</th>
              <th scope="col" class="text-white border border-white" id="common" >Life Time Total</th>
              <th scope="col" class="text-white border border-white" id="common" >Topup Useds</th>
              <th scope="col" class="text-white border border-white" id="common" >Topup Minutes</th>
              <th scope="col" class="text-white border border-white" id="common" >Monthly Usage Reset Day</th>
              <th scope="col" class="text-white border border-white" id="common" >Total Sessions</th>
              <th scope="col" class="text-white border border-white" id="common" >Site Id</th>
              <th scope="col" class="text-white border border-white" id="common" >Last Login</th>
              <th scope="col" class="text-white border border-white" id="common" >Actions</th>
            </tr>
           </thead>
          <tbody>
          
            <tr *ngFor="let item of value">
              <td class="text-center">
                <div style="vertical-align: middle;display: flex;padding: 10px 22px;" >
                  <input type="checkbox" [(ngModel)]="item.selected" (change)="update(item)" >
                </div>
              </td>
               <td class="text-center">
                 {{item.uni-id}}
              </td>   
                <td class="text-center">
                {{item.userID}}
             </td>
             <td class="text-center">
              {{item.acc}}
           </td>
           <td class="text-center">
            {{item.Quota}}
         </td>
         <td class="text-center">
            {{item.Today}}
         </td>  
         <td class="text-center">
            {{item.weel}}
         </td>
         <td class="text-center">
            {{item.month}}
         </td>
         <td class="text-center">
            {{item.life}}
         </td>
         <td class="text-center">
            {{item.top}}
         </td>
         <td class="text-center">
            {{item.top-v}}
         </td>
         <td class="text-center">
            {{item.m-u}}
         </td>
         <td class="text-center">
            {{item.Quota1}}
         </td>
         <td class="text-center">
            {{item.Today1}}
         </td>
         <td class="text-center">
            {{item.week}}
         </td>
         <td class="text-center">
            {{item.m}}
         </td>
         <td class="text-center">
            {{item.l}}
         </td>
         <td class="text-center">
            {{item.t}}
         </td>
         <td class="text-center">
            {{item.v}}
         </td>
         <td class="text-center">
            {{item.r}}
         </td>
         <td class="text-center">
            {{item.ts}}
         </td>
         <td class="text-center">
            {{item.l-l}}
         </td>
         <td class="text-center">
            {{item.sid}}
         </td>

         <td class="text-center">
            <div class="action" >
              <button class="btn1 text-center" id="ha" style="background-color:#0071bc;" (click)="userclick()">
                    <i class="fa fa-bars text-white"></i>
                </button>
          
                <!-- Hover Menu Container (Initially Hidden) -->
                <div class="container  action-menu" *ngIf="show">
                  <div style="display: flex;">
                    <button class="btn  text-center text-white mx-1"  (click)="openLarge(content1)" id="c" style="background-color:green"><span class=" text-white"><i class="bi bi-plus" id="e" ></i></span></button>
                    <button class="btn  text-center text-white mx-1"  (click)="openLarge(content1)" id="c" style="background-color:deeppink"><span><i class="bi bi-pen " id="e"></i></span></button>
                     <button class="btn  text-center text-white mx-1"  (click)="openLargeview(content4)" id="c" style="background-color: dodgerblue;"><span><i class="bi bi-eye" id="e"></i></span></button>
                    
                  </div>
              </div>
          </div> 
           
          </td>
       
          </tbody>
        </table>
        <!-- !----!---! -->
        </div>
        <!-- !----!card body end---! -->
     </div>
      <!-- !----!pagination start----! -->
      <div class="mt-3 mx-3">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item">
              <a class="page-link" href="#" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item">
              <a class="page-link" href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
       </div>
     <!-- !----! main card end---! -->
      </div>
     <!-- !----!pagination end ----! -->
    
    
    
    </div>
     <!-- !----!card  end-----! -->
  <!-- !----!pop up modal----! -->
  
  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content1 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite;" >
          <div class="container ">
            <h3 style="background:linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; " class="text-center">Enter Usage Plans Details</h3> 
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border: none;">
          </button>
        </div>
        <div class="modal-body pb-5 " style="background-color:ghostwhite;padding-left:25px;" >
          <div class="col-lg-12 row  " style="padding:20px 20px;justify-content: center;">
            <div class="col-lg-6">
            <label class="col-lg-6 fw-bold" id="label">Unique ID</label>
              <div class="col-lg-12 mt-2 ">
                <input type="number" class="form-control" formControlName="Plan_Id">
              </div>
            </div>
              <!-- !----!---! -->
  
            <div class="col-lg-6  ">
            <label class="col-lg-6"id="label">User ID</label>
              <div class="col-lg-12 mt-2">
                <input type="number" class="form-control" formControlName="plan_name">
              </div>
             </div>
            <!-- !----!---! -->
            <div class="col-lg-6 mt-2">
            <label class="col-lg-6"id="label">Name</label>
              <div class="col-lg-12 mt-2" >
                <input type="text" class="form-control" formControlName="Plan_type">
              </div>
             </div>
           <!-- !-----!---! -->
             <div class="col-lg-6 mt-2">
              <label class="col-lg-6" id="label">Account State</label>
              <div class="col-lg-12 mt-2">
                <input type="text" class="form-control" formControlName="payment_type">
              </div>
           </div>
           <!-- !---!---! -->
           <div class="col-lg-6 mt-2">
            <label class="col-lg-6" id="label">Quota</label>
              <div class="col-lg-12 mt-2">
                <input type="number" class="form-control" formControlName="groups">
              </div>
           </div>
           <!-- !----!-----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Today</label>
              <div class="col-lg-12 mt-2">
                <input type="text" class="form-control" formControlName="user">
              </div>
           </div>
           <!-- !----!---! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">This Week</label>
              <div class="col-lg-12 mt-2">
                <input type="text" class="form-control" formControlName="Bandwidth">
              </div>
           </div>
           <!-- !----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">This Month</label>
              <div class="col-lg-12 mt-2">
                <input type="text" class="form-control" formControlName="Update">
              </div>
           </div>
           <!-- !----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Life Time Total</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="data_transfer">
              </div>
           </div>
            
           <!-- !----!---! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Topup Used</label>
              <div class="col-lg-12 mt-2">
                <input type="time" class="form-control" formControlName="time_plan">
              </div>
           </div>
           <!-- !----!---! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Topup Value</label>
              <div class="col-lg-12 mt-2">
                <input type="time" class="form-control" formControlName="time_frame">
              </div>
           </div>
           <!-- !----!---! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label"> Month Usage Form</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="month-usage">
              </div>
           </div>
           <!-- !----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Quota(Minutes)</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="quo-min">
              </div>
           </div>
           <!-- !-----!---! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Today</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="today">
              </div>
           </div>
           <!-- !-----!-----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">This Week </label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="this-week">
              </div>
           </div>
           <!-- !-----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">This Month</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="this-month">
              </div>
           </div>
           <!-- !----!---! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Life Time Total </label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="life-time-total">
              </div>
           </div>
           <!-- !-----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Topup Useds</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="topup-used">
              </div>
           </div>
           <!-- !-----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Topup Minutes</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="topup-min">
              </div>
           </div>
           <!-- !----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Monthly Usage Reset Day</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="reset-days">
              </div>
           </div>
           <!-- !------!-----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Total Sessions</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="total-sessions">
              </div>
           </div>
           <!-- !----!-----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Site Id</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="site-Id">
              </div>
           </div>
           <!-- !----!---! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">Last Login</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="last-login">
              </div>
           </div>
           <!-- !----!----! -->
           <div class="col-lg-6 mt-2 ">
            <label class="col-lg-6" id="label">User Id</label>
              <div class="col-lg-12 mt-2">
                <input type="type" class="form-control" formControlName="last-login">
              </div>
           </div>



           <!-- !-----!---! -->

          </div>
        </div>
        <div class="modal-footer" style="background-color: ghostwhite;" >
          <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:#0071bc">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:#0071bc"(click)="c('Close click')">Close</button>
         
        </div>
      </ng-template>
    </div>
  </div>
  <!-- !----!search----! -->
  <div class="card main-card mb-3 bg-info " style="display: none;">
    <div class="card-body" style="background-color: ghostwhite;">
      <ng-template #content7 let-c="close" let-d="dismiss">
        <div class="modal-header">
          <div class="container text-center">
            <h4 class="modal-title" style="background:linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px;">Search Customer Details</h4>
          </div>
         
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
          </button>
        </div>
        <div class="modal-body" style="background-color: ghostwhite;padding:40px;">
          <div class="col-lg-12  row" style="padding:20px 15px;">
           <label class="col-form-label col-lg-3" id="label">Search</label>
           <div class="col-lg-8">
            <input type="text" class="form-control" formControlName="serach_id">
           </div>
          </div>
        </div>
        <div class="modal-footer" style="background-color: ghostwhite;;">
          <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:#0071bc">Save </button>
          <button type="button" class="btn text-center text-white fw-bold px-4" (click)="c('Close click')" style="background-color:#0071bc">Close</button>
      
        </div>
      </ng-template>
  
    </div>

    <!-- !----!_---! -->
  </div>

  <div class="card main-card " style="display: none;">
    <div class="card-body">
      <ng-template #content4 let-c="close" let-d="dismiss">
        <div class="modal-header" style="background-color: ghostwhite" >
          <div class="container ">
            <h3 style="background:linear-gradient(90deg, #0071bc, #33a1f2);color: white;font-weight: bold;padding:7px 50px; " class="text-center">View Customer Details</h3> 
          </div>
          <button type="button" class="btn-close " (click)="c('Cross click')" style="border: none;">
          </button>
        </div>
        <div class="modal-body pb-5 " style="background-color:ghostwhite;" >
         <div class="col-lg-12  row">
           <label class="col-form-label col-lg-4  text-center fw-bold" id="label">Plan Id</label>
           <div class="col-lg-7 ">
            <input class="form-control">
           </div>
           <!-- !----!----! -->

           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">Plan Name</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!----! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3"id="label" >Plan Type</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !------! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label" >Payment Type</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!----! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">Group</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!----! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3"id="label" >Users</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!---! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">Download Bandwidth</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!-----! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3"id="label" >Upload Bandwidth</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control" type="file">
           </div>
           <!-- !----!---! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3"id="label" >Data Transfer Quota</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!---! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3"id="label" >Time Frame</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!----! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">Generative Invoice</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !----!--!       -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">Email Alerts</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !----!----! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">Alerts Template</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!---! -->
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">SMS Alerts</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3" id="label">Alerts Template</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <label class="col-form-label col-lg-4 text-center fw-bold mt-3" id="label">Popup Window Template</label>
           <div class="col-lg-7  mt-3">
            <input class="form-control">
           </div>
           <label class="col-form-label col-lg-4  text-center fw-bold mt-3"id="label" >Revnue Share(ISP %)</label>
           <div class="col-lg-7 mt-3">
            <input class="form-control">
           </div>
           <!-- !-----!---! -->
          

           <!-- !----!----! -->
         </div>

         <!-- !-----!-----! -->

        </div>
        <div class="modal-footer" style="background-color: ghostwhite;" >
          <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:linear-gradient(90deg, #0071bc, #33a1f2)">Save</button>
          <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:linear-gradient(90deg, #0071bc, #33a1f2)"(click)="c('Close click')">Close</button>
         
        </div>
      </ng-template>
    </div>
  </div>
  
  